import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { ContactUsDetails } from '../contactUsDetails/contactUsDetails';
import { CSPUrlsMap } from '../../routes/CSPUrlsMap';
import './authErrorPage.scss';

export const AuthErrorPage = () => {
  const loginUrl = `${window.location.origin}${CSPUrlsMap.login.url}`;
  const { logout } = useAuth0();

  const handleBackToLogin = () => {
    sessionStorage.clear();
    localStorage.clear();
    logout({
      logoutParams: { returnTo: loginUrl }
    });
  };

  return (
    <div className="petSureForm verticalStacked authErrorPage">
      <main aria-label="Authentication Error page">
        <div className="content">
          <h2>Authentication Error</h2>
          <span>
            An error has occurred while trying to authenticate your account. If the issue persists, please contact us
            for assistance.
          </span>
        </div>
        <div className="button-container">
          <button
            type="button"
            className="button primary"
            onClick={handleBackToLogin}
          >
            <span>Back to login</span>
          </button>
        </div>
      </main>
      <aside>
        <ContactUsDetails />
      </aside>
    </div>
  );
};
